import React from 'react';

import {
  Container,
  HeaderContainer,
  NotFoundBackgroundHeader,
  Header,
  ContainerImageNotFound,
  NotFoundTitle,
  NotFoundSubtitle,
} from './styles';

import notfound from '~/assets/icons/404.svg';
import logo from '~/assets/images/logo.svg';

function NotFound() {
  return (
    <Container>
      <HeaderContainer>
        <NotFoundBackgroundHeader BackgroundHeight="150px" />
        <Header>
          <img src={logo} alt="HIAE" />
        </Header>
        <NotFoundTitle>Ops!</NotFoundTitle>
      </HeaderContainer>
      <ContainerImageNotFound>
        <img src={notfound} alt="404" />
        <NotFoundSubtitle>
          Não encontramos essa página. Certifique-se de ter digitado a url
          corretamente.
        </NotFoundSubtitle>
      </ContainerImageNotFound>
    </Container>
  );
}

export default NotFound;
